import { BoxProps } from "@mui/material";
import { Box, CsiImage, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageLS from "./LandscapeSmallImage.jpg";
import imagePS from "./PortraitSmallImage.jpg";

const ContainerBox = (props: BoxProps) => (
	<Box
		bgcolor="grey.200"
		border={STANDARD_BORDER_STYLE}
		display="inline-block"
		width={200}
		{...props}
	/>
);

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="1 : 1" />
			<Text semiBold text="16 : 9" />
			<ContainerBox>
				<CsiImage aspectRatio={1} src={imageLS} />
			</ContainerBox>
			<ContainerBox>
				<CsiImage aspectRatio={16 / 9} src={imagePS} />
			</ContainerBox>
		</CssColumnGrid>
	);
};